:host {
  --view-container-padding: 0 0 var(--spacer) calc(5 * var(--spacer));
  --leaf-item-padding: 0 calc(6 * var(--spacer)) 0 calc(4 * var(--spacer));
  --node-item-padding: 0 calc(6 * var(--spacer)) 0 calc(2 * var(--spacer));

  display: flex;
  height: 100%;
  width: 100%;
}

.view-container {
  flex: 1;
  background-color: var(--white-layout-301-level-0-elevation);
  padding: var(--view-container-padding);
  overflow: hidden;
  position: relative;
}

gz-labeled-content {
  height: auto;
}
